var searchForm = {

    configuration: null,
    elements: {},

    init: function() {
        if(typeof searchFormConfiguration == 'undefined') {
            return;
        }

        this.configuration = searchFormConfiguration;

        if(!this.getElements()) {
            return;
        }

        this.setUpAdaptedInput();
        this.setEvents();
        this.setRenderProductCardHook();
    },

    getElements: function() {
        this.elements.form = jQuery('.search-form');
        if(!this.elements.form.length) {
            return false;
        }

        this.elements.input = jQuery('.search-form__input');
        if(!this.elements.input.length) {
            return false;
        }

        return true;
    },

    setUpAdaptedInput: function() {
        this.elements.adaptedInput = this.elements.form.find('.search-form__adapted-input');

        if(!this.elements.adaptedInput.length) {
            this.elements.adaptedInput = jQuery('<input class="search-form__adapted-input" type="hidden" name="q" data-search />');
            this.elements.form.append(this.elements.adaptedInput);
        }

        // Remove name attribute value so that value will not be included in form submissions.
        this.elements.input.removeAttr('name');

        // Remove search capability of original input element by overriding input event handlers.
        this.elements.input.each(function() {
            this.oninput = null;
        });

        // Initialize Booster theme search element functionality so that event handlers are applied to the new input element.
        BoosterTheme.ELEMENTS.initSearch();
    },

    setEvents: function() {
        var _self = this;

        this.elements.input.on('change keyup', function(event) {
            var query = _self.elements.input.val();

            query = _self.addAssociatedSearchTerms(query);
            _self.elements.adaptedInput.val(query);
            _self.triggerAdaptedSearchSuggest();
        });
    },

    addAssociatedSearchTerms: function(query) {
        if(typeof this.configuration.associatedSearchTerms == 'undefined') {
            return query;
        }

        var allAssociatedSearchTerms = this.configuration.associatedSearchTerms;

        for(var i=0; i<allAssociatedSearchTerms.length; i++) {
            var associatedSearchTerms = allAssociatedSearchTerms[i];
            var firstSearchTerm = associatedSearchTerms[0];

            if(query.indexOf(firstSearchTerm) !== -1) {
                query = query.replace(
                  firstSearchTerm,
                  associatedSearchTerms.map(
                    function(term) {
                      return '"' + term + '"';
                    }
                  ).join(
                    ' OR '
                  )
                );

                continue;
            }
        }

        return query;
    },

    triggerAdaptedSearchSuggest: function() {
        this.elements.adaptedInput.each(function() {
            this.dispatchEvent(new Event('input', {bubbles:true}));
        });
    },

    setRenderProductCardHook: function() {
      var _self = this;

      BoosterTheme.ELEMENTS.renderProductCardOriginal = BoosterTheme.ELEMENTS.renderProductCard;
      BoosterTheme.ELEMENTS.renderProductCard = function(product) {
        var card = BoosterTheme.ELEMENTS.renderProductCardOriginal(product);

        if(_self.productIsUnavailable(product)) {
          card = _self.applyUnavailableCardState(card);
        }

        return card;
      };
    },

    productIsUnavailable: function(product) {
      if(!product.available) {
        return true;
      }

      var url = new URL(location.origin + product.url);

      var selectedVariantId = url.searchParams.get('variant');

      if(!selectedVariantId) {
        return false;
      }

      var selectedVariant = product.variants.filter(
        function(variant) {
          return variant.id == selectedVariantId;
        }
      ).shift();

      if(!selectedVariant) {
        return false;
      }

      if(!selectedVariant.available) {
        return true;
      }

      return false;
    },

    applyUnavailableCardState: function(card) {
      card = jQuery(card);

      card.addClass('card--unavailable');

      var imgContainer = card.find('.card__img--container');

      if(!imgContainer.length) {
        return card.get().shift();
      }

      var availabilityMessage = jQuery(document.getElementById('productCardAvailabilityMessageTemplate').content.cloneNode(true).children.item(0));

      if(!availabilityMessage.length) {
        return card.get().shift();
      }

      imgContainer.prepend(availabilityMessage);

      return card.get().shift();
    }

};

function initSearchForm() {
    if(typeof BoosterTheme == 'undefined') {
        setTimeout(initSearchForm, 200);
    
        return;
      }
    
      searchForm.init();
}

jQuery(document).ready(function() {
    initSearchForm();
});